<template>
  <AnimatedContainer>
    <div
      v-if="links.length > 0"
      class="
        slide-left rounded-bl-xl bg-red-500 p-7 pb-6
        print:hidden
      "
    >
      <!-- TITLE -->
      <h3 class="typo-h-3 mb-5 text-white">
        {{ data.heading || globals?.sidebar_card_links?.heading }}
      </h3>

      <!-- LINKS -->
      <div class="space-y-3">
        <template v-for="item in links">
          <AppButton
            v-if="item.link"
            :key="item.id"
            :to="item.link"
            class="group w-full"
            variant="white"
            :aria-label="item.link_text"
          >
            <span>{{ item.link_text }}</span>
            <IconArrowRight
              class="
                ml-auto h-3 shrink-0 transition-transform duration-300
                ease-in-out
                group-hover:translate-x-1
              "
            />
          </AppButton>
        </template>
      </div>
    </div>
  </AnimatedContainer>
</template>

<script setup lang="ts">
import type { SidebarComponentsSidebarCardLinksFragment } from '#gql'

const props = defineProps<{ data: Enforce<SidebarComponentsSidebarCardLinksFragment> }>()

const globals = inject(GlobalsKey, null)

const links = computed(() => {
  if (Array.isArray(props.data.links) && props.data.links.length) {
    return props.data.links
  }

  return globals?.value?.sidebar_card_links?.links
})
</script>
